import { RtspConfig } from 'types/rtsp_config';

export const CAMERA_CONNECTION_TYPES = ['local', 'remote', 'virtual'] as const;
export type CameraConnectionType = (typeof CAMERA_CONNECTION_TYPES)[number];

export function isCameraConnectionType(
  state: string
): state is CameraConnectionType {
  return ([...CAMERA_CONNECTION_TYPES] as string[]).includes(state);
}

export const CAMERA_STATES = [
  'online',
  'offline',
  'unknown',
  'unauthorized',
] as const;
export type CameraState = (typeof CAMERA_STATES)[number];

export function isCameraState(state: string): state is CameraState {
  return ([...CAMERA_STATES] as string[]).includes(state);
}

export type Framerate = {
  denom: number;
  numer: number;
};

export type CameraConfiguration = {
  aperture?: string;
  format?: string;
  resolution?: string;
  framerate?: Framerate | number | null;
  width?: number | null;
  height?: number | null;
  capacity?: string;
};

export type CameraCapability = {
  name: string | null;
  width: number | null;
  format: string | null;
  height: number | null;
  framerates: Framerate[];
};

export type Camera = {
  readonly id: string;
  application_id: string;
  name: string;
  status: CameraState;
  model: string | null;
  conn_type: CameraConnectionType;
  uri: string | null;
  gateway_id: string | null;
  ip_local: string | null;
  ip_ext: string | null;
  mac_address: string | null;
  username: string | null;
  password: string | null;
  configuration: CameraConfiguration | null;
  capabilities: CameraCapability[] | null;
  snapshot_file_id: string | null;
  tags: string[];
  reference_pipeline_ids: string[];
  reference_deployment_ids: string[];
  external_id: string | null;
  rtsp_config: RtspConfig | null;
  readonly created_at: string;
  readonly updated_at: string;
};
